module.exports = __webpack_public_path__ + "img/datch-add.5fdc13b0.png";